
export const handleEditWebTitle = res => {
  var Ip = window.location.host;
  var webName = ""
  if (Ip.includes('253')) {
    webName = "253·手抓饼"
  } else if (Ip.includes('kuaie01')) {
    webName = "kuaie01·手抓饼"
  } else if (Ip.includes('kuaie02')) {
    webName = "kuaie02·手抓饼"
  } else {
    webName = "手抓饼"
  }
  return webName
}


export default {
  title: handleEditWebTitle(),
  // （测试）
  subtitle: 'HuaBing',
  copyright: 'Copyright © 2021 HuaBing.com. All rights reserved.',
  isFirstPage: true,// 配置首页不可关闭
  key: 'pigx', // 配置主键,目前用于存储
  websocket: false, // 是否开启websocket
  whiteList: ['/login', '/404', '/401', '/lock'], // 配置无权限可以访问的页面
  whiteTagList: ['/login', '/404', '/401', '/lock'], // 配置不添加tags页面 （'/advanced-router/mutative-detail/*'——*为通配符）
  fistPage: {
    label: '首页',
    value: '/wel/index',
    params: {},
    query: {},
    group: [],
    close: false
  },
  // 配置菜单的属性
  menu: {
    props: {
      label: 'label',
      path: 'path',
      icon: 'icon',
      children: 'children'
    }
  }
}
